import { Country } from '@nkr/enums/country';
import { IListItem, IWatrRequest } from '@nkr/models/index';
import { Col, ListGroup, ListGroupItem, Panel, Row } from 'react-bootstrap'
import { useDonorShieldNavigation } from '../../../../../hooks/use-donor-shield-navigation';

interface IProps {
    data: IWatrRequest,
    donationTypes: IListItem[]
}

const DonorInformation = (props: IProps) => {
    const { navigateToDonorShield, isGeneratingToken } = useDonorShieldNavigation();

    const handleDashboardLinkClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        await navigateToDonorShield(props.data.id, 'dashboard');
    };
    return (
        <Panel eventKey='1'>
            <Panel.Heading style={{ paddingTop: 5, paddingBottom: 5 }}>
                <Panel.Title toggle style={{ fontSize: 14 }}>Donor Information</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
                <ListGroup>
                    <ListGroupItem>
                        <h4 className='list-group-item-heading'>General</h4>
                        <div className='list-group-item-text'>
                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Alias:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.alias}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>First Name:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.firstName}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Last Name:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.lastName}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Date of Birth:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.birthDate}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Organ Type:</Col>
                            <Col xs={12} md={6} lg={6}>
                                {props.data.donationOrganType == 1 ? 'Liver' : 'Kidney'}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Donation Type:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.donationTypeDesc}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Donation Confirmed:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.donationConfirmed ? 'Yes' : 'No'}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Donor Shield Id:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.donorShieldId == undefined ? 'N/A' : props.data.donorShieldId}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Is Approval Recommended:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.isApprovalRecommended ? 'Yes' : 'No'}</Col>
                        </Row>
                        </div>
                    </ListGroupItem>

                    <ListGroupItem>
                        <h4 className='list-group-item-heading'>Address</h4>
                        <div className='list-group-item-text'>
                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Address:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.addressLine1}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>City:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.city}</Col>
                        </Row>

                        {props.data.country == Country.UnitedStates ?
                            <Row>
                                <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>State:</Col>
                                <Col xs={12} md={6} lg={6}>{props.data.stateAbbr}</Col>
                            </Row>
                            :
                            <Row>
                                <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>State/Region/Locality:</Col>
                                <Col xs={12} md={6} lg={6}>{props.data.province}</Col>
                            </Row>
                        }

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Postal Code:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.postalCode}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Country of Residence:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.countryName}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Country of Citizenship:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.countryOfCitizenshipName}</Col>
                        </Row>
                        </div>
                    </ListGroupItem>

                    <ListGroupItem>
                        <h4 className='list-group-item-heading'>Contact</h4>
                        <div className='list-group-item-text'>
                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Email:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.email}</Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={6} lg={6} style={{ fontWeight: 500 }}>Mobile:</Col>
                            <Col xs={12} md={6} lg={6}>{props.data.mobile}</Col>
                        </Row>
                        </div>
                    </ListGroupItem>
                </ListGroup>

                <div style={{ display: 'block', justifyContent: 'space-between' }}>
                    <div>
                        <Row>
                            <Col xs={6} md={12} lg={12}>
                                <a className='btn btn-default form-control'
                                    href='#'
                                    onClick={handleDashboardLinkClick}
                                    style={{ pointerEvents: isGeneratingToken ? 'none' : 'auto', opacity: isGeneratingToken ? 0.6 : 1 }}>
                                    {isGeneratingToken ? 'Generating...' : 'Dashboard Link'}
                                </a>
                            </Col>
                        </Row>

                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default DonorInformation;